import { BusinessArea } from "./businessArea";
import { OperetionHistoryDTO } from "./operationHistory";

//TODO: Change to Lab class and remove the implementation of Enum.
//this model is used to define the lab properties
export class LabMDM {

    _id: string;
  
    /** The Name of a lab. */
    name:string;
        
    /** The mix2seq ID of a lab. */
    mix2SeqLabId:number;

	/** The location business area combination. */
    businessArea :BusinessArea ;
    
    /** The location. */
    location:string ;
	
	/** The lab manager name. */
    manager:string ;

	/** The countryName of a lab. */
    countryName:string;

    /** The countryCode of a lab. */   
    countryCode:string;
	
	/** The timezone. */
    timeZone: string ;
	
	/** The default language. */
    defaultLanguage:string ;

    /** describes if the lab is activated or not. */
    active:boolean;

    managementRole: string[];

    numberOfPC:number;
    numberOfNC:number;
    numberOfPositivePCRControls:number;
    numberOfNegativePCRControls:number;
    clippingMachine:boolean;
    unboxingInBatches:boolean;
    reducedConfirmationTests:boolean;
    reportingOutsideBB:boolean;
    flaTestProcess:boolean;
    batchIDRegex:string;
    dateTimeFormat:string;
    dateFormat:string;
    workfileNameFormat:string;
    modificationHistory:OperetionHistoryDTO[];
}

export interface SelectableLab {
    label: string,
    lab: LabMDM
}